import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import _ from "lodash";
import { useContext } from "react";
import {
  StyleTypeContext,
  TranslationContext,
} from "../../../../umbilical_tools";
import jssVariables from "../../../../jss_setup";
import tinycolor from "tinycolor2";
import { useSelector } from "react-redux";
import { Form } from "formik";
import { BackBtn, SubmitGuestBtn } from "../conponents";
import { TravellerForm } from "./TravellerForm";

const checkboxStyles = createUseStyles({
  CheckBoxComp: (props) => ({
    ..._.get(props, "customStyles.CheckBoxComp", {}),
  }),
  checkbox: (props) => ({
    display: "inline-flex",
    alignItems: "center",
    "& input": {
      display: "none",
    },
    "& span": {
      position: "relative",
      display: "inline-block",
      width: 20,
      height: 20,
      marginRight: 8,
      border: `2px solid #bfbfbf`,
      background: tinycolor("#bfbfb").lighten(95).toRgbString(),
      borderRadius: 4,
      transition: "all 0.3s",
      cursor: "pointer",
      fontSize: 16,
      color: "transparent",
      fontWeight: "bold",
      textAlign: "center",
      lineHeight: "20px",
    },
    "& input:checked + span": {
      backgroundColor: "#ff9800",
      borderColor: "#ff9800",
      color: "#fff",
    },
    ..._.get(props, "customStyles.checkbox", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
export const CheckBoxComp = ({
  checked,
  setChecked,
  type,
  setSelectedType,
  selectedType,
}) => {
  const classes = checkboxStyles({});

  function onChangeHandle() {
    if (selectedType === type && checked) {
      setSelectedType("");
    } else {
      setSelectedType(type);
    }
    setChecked(!checked);
  }

  return (
    <div className={classes.CheckBoxComp}>
      <label className={classes.checkbox}>
        <input type="checkbox" checked={checked} onChange={onChangeHandle} />
        <span>✓</span>
      </label>
    </div>
  );
};
CheckBoxComp.defaultProps = {
  checked: false,
  type: "",
  selectedType: "",
};
CheckBoxComp.propTypes = {
  checked: PropTypes.bool.isRequired,
  setChecked: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func,
  selectedType: PropTypes.string.isRequired,
};

const formStyles = createUseStyles({
  TravellerForms: (props) => ({
    display: "grid",
    gridTemplateRows: "1fr max-content",
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.TravellersForms", {}),
  }),
  travellerFormContr: (props) => ({
    display: "grid",
    gridGap: jssVariables.normal_gap,
    height: "max-content",
    maxHeight: "70vh",
    boxShadow: jssVariables.shadows.normalShadow,
    padding: jssVariables.double_gap,
    borderRadius: jssVariables.half_gap,
    alignContent: "baseline",
    ..._.get(props, "customStyles.TravellersForms", {}),
  }),
  passengersTitle: (props) => ({
    background: jssVariables.colors.base_color,
    color: jssVariables.colors.text.light,
    fontSize: "medium",
    fontWeight: 500,
    padding: [jssVariables.normal_gap, jssVariables.normal_gap],
    borderRadius: jssVariables.half_gap,
    ..._.get(props, "customStyles.passengersTitle", {}),
  }),
  form: (props) => ({
    display: "grid",
    gridTemplateColumns: "1fr",
    alignContent: "baseline",
    gridGap: jssVariables.normal_gap,
    padding: jssVariables.normal_gap,
    overflowY: "auto",
    height: "55vh",
    ..._.get(props, "customStyles.form", {}),
  }),
  divider: (props) => ({
    height: "2px",
    background: jssVariables.colors.border,
    width: "100%",
    ..._.get(props, "customStyles.divider", {}),
  }),
  actions: (props) => ({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: jssVariables.normal_gap,
    ..._.get(props, "customStyles.actions", {}),
  }),

  [`@media ${jssVariables.media.smallscreen}`]: {
    form: (props) => ({
      gridTemplateColumns: "repeat(3,1fr)",
      ..._.get(props, "customStyles.form.smallscreen", {}),
    }),
    divider: (props) => ({
      gridColumn: "span 3",
      ..._.get(props, "customStyles.divider.smallscreen", {}),
    }),
  },
  [`@media ${jssVariables.media.bigscreen}`]: {},
});
const TravellerForms = ({ prebookData, backBtnProps, requiredFields }) => {
  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const { t } = useContext(TranslationContext);

  var { adults, youths, seniors } = useSelector((state) => {
    return {
      adults: state.TrainSearchForm.adults,
      youths: state.TrainSearchForm.youths,
      seniors: state.TrainSearchForm.seniors,
    };
  });

  const classes = formStyles({
    customStyles: cStyler({
      type,
      brand,
      objName: "TravellerForms",
    }),
  });

  const departure = _.get(prebookData, "booking_items.0.legs.0.departure", "");

  return (
    <div className={classes.TravellerForms}>
      <div className={classes.travellerFormContr}>
        <div className={classes.passengersTitle}>{t("passengerDetails")}</div>
        <Form className={classes.form}>
          <TravellerForm
            trvlIdxOffset={0}
            ageType="adults"
            requiredFields={requiredFields}
            departure={departure}
          />
          {seniors > 0 && adults > 0 && <hr className={classes.divider} />}
          <TravellerForm
            trvlIdxOffset={adults}
            ageType="seniors"
            requiredFields={requiredFields}
            departure={departure}
          />
          {youths > 0 && (adults > 0 || seniors > 0) && (
            <hr className={classes.divider} />
          )}
          <TravellerForm
            trvlIdxOffset={adults + seniors}
            ageType="youths"
            requiredFields={requiredFields}
            departure={departure}
          />
        </Form>
      </div>
      <div className={classes.actions}>
        <BackBtn backBtnProps={backBtnProps} />
        <SubmitGuestBtn t={t} id="trains_next_btn" />
      </div>
    </div>
  );
};
TravellerForms.defaultProps = {
  backBtnProps: {},
  prebookData: {},
  requiredFields: {},
};
TravellerForms.propTypes = {
  backBtnProps: PropTypes.object.isRequired,
  prebookData: PropTypes.object.isRequired,
  requiredFields: PropTypes.object.isRequired,
};
export default TravellerForms;
